"use strict";

import Dom from "common/Dom";
export const accordionToggle = function accordionToggle($el) {
  $el.toggleClass("is-open");
  $el.next($(Dom.accordionText)).slideToggle();
};
